export const ST_1_DigiCodeTrackCircuit_Schema = [
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [{ title: "Reason for Adjustment", colSpan: 18, leftAlign: true, accessor: "ballast" }],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [
      { title: "Track No. ", colSpan: 6, leftAlign: true, accessor: "track" },
      { title: "Channel", colSpan: 6, leftAlign: true, accessor: "channel" },
      { title: "Code", colSpan: 6, leftAlign: true, accessor: "code" },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [{ title: "Measured Values", colSpan: 18, leftAlign: false, isTitleOnly: true }],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [
      { title: "V.RX ", colSpan: 6, rowSpan: 1, accessor: "vRX", leftAlign: true },
      { title: "V.OUT ", colSpan: 6, rowSpan: 1, accessor: "vout", leftAlign: true },
      { title: "VTX ", colSpan: 6, rowSpan: 1, accessor: "vtx", leftAlign: true },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [
      { title: "Transmitter End", colSpan: 6, rowSpan: 1, accessor: "loc", isTitleOnly: true },
      { title: "Current (Irail)", colSpan: 6, rowSpan: 1, accessor: "tCurrent" },
      { title: "Voltage (Vrail)", colSpan: 6, rowSpan: 1, accessor: "tVoltage" },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [
      { title: "Receiver End", colSpan: 6, rowSpan: 1, accessor: "loc", isTitleOnly: true },
      { title: "Current (Irail)", colSpan: 6, rowSpan: 1, accessor: "r1Current" },
      { title: "Voltage (Vrail)", colSpan: 6, rowSpan: 1, accessor: "r1Voltage" },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [{ title: "divider", colSpan: 18, rowSpan: 1, accessor: "loc", isValueOnly: true, disable: true }],
  },

  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [{ title: "Shunt Verification", colSpan: 18, rowSpan: 1, accessor: "loc", isTitleOnly: true }],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [
      { title: "Transmitter End", colSpan: 6, rowSpan: 1, accessor: "loc", isTitleOnly: true },
      { title: "Middle of TC", colSpan: 6, rowSpan: 1, accessor: "requiress", isTitleOnly: true },
      { title: "Receiver End", colSpan: 6, rowSpan: 1, accessor: "requiress", isTitleOnly: true },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [
      { title: "", colSpan: 3, rowSpan: 1, accessor: "loc", isTitleOnly: true, disable: true },
      { title: "VRX", colSpan: 3, rowSpan: 1, accessor: "shuntapplyR1", isTitleOnly: true },
      { title: "", colSpan: 3, rowSpan: 1, accessor: "requiress", isTitleOnly: true, disable: true },
      { title: "VRX", colSpan: 3, rowSpan: 1, accessor: "loc", isTitleOnly: true },
      { title: "", colSpan: 3, rowSpan: 1, accessor: "requiress", isTitleOnly: true, disable: true },
      { title: "V.RX", colSpan: 3, rowSpan: 1, accessor: "requiress", isTitleOnly: true },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [
      { title: ".5 Ω", colSpan: 3, rowSpan: 1, accessor: "loc", isTitleOnly: true },
      { title: "VRX", colSpan: 3, rowSpan: 1, accessor: "fiveOhm", isValueOnly: true },
      { title: "0.06Ω ", colSpan: 3, rowSpan: 2, accessor: "requiress", isTitleOnly: true },
      { title: "VRX", colSpan: 3, rowSpan: 2, accessor: "middleTC6o", isValueOnly: true },
      { title: ".5 Ω", colSpan: 3, rowSpan: 1, accessor: "requiress", isTitleOnly: true },
      { title: "V.RX", colSpan: 3, rowSpan: 1, accessor: "receiverEnd5o", isValueOnly: true },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [
      { title: ".06Ω", colSpan: 3, rowSpan: 1, accessor: "loc", isTitleOnly: true },
      { title: "VRX", colSpan: 3, rowSpan: 1, accessor: "sixOhm", isValueOnly: true },
      { title: ".06Ω", colSpan: 3, rowSpan: 1, accessor: "requiress", isTitleOnly: true },
      { title: "V.RX", colSpan: 3, rowSpan: 1, accessor: "receiverEnd6o", isValueOnly: true },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [
      { title: "Adjacent TC status", colSpan: 6, rowSpan: 1, accessor: "adjacentTCstatus", leftAlign: true },
      { title: "", colSpan: 6, rowSpan: 4, accessor: "loc", leftAlign: true, isTitleOnly: true, disable: true },
      { title: "Adjacent TC status", colSpan: 6, rowSpan: 1, accessor: "adjacentTCstatus3", leftAlign: true },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [
      { title: "Center of S-bond shunt verification", colSpan: 6, rowSpan: 1, accessor: "loc", isTitleOnly: true },
      { title: "Center of S-bond shunt verification", colSpan: 6, rowSpan: 1, accessor: "loc", isTitleOnly: true },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [
      { title: "TC under test status", colSpan: 6, rowSpan: 1, accessor: "tcTestStatus", leftAlign: true },
      { title: "TC under test status", colSpan: 6, rowSpan: 1, accessor: "tcStatus2", leftAlign: true },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [
      { title: "Adjacent TC status", colSpan: 6, rowSpan: 1, accessor: "adjacentTCstatus2", leftAlign: true },

      { title: "Adjacent TC status", colSpan: 6, rowSpan: 1, accessor: "adjacentTCstatus4", leftAlign: true },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [
      { title: "P1 Jumper", colSpan: 9, rowSpan: 1, accessor: "loc", isTitleOnly: true },
      { title: "P1", colSpan: 3, rowSpan: 1, accessor: "p25JumperP1", leftAlign: true },
      { title: "P3", colSpan: 3, rowSpan: 1, accessor: "p25JumperP3", leftAlign: true },
      { title: "P5", colSpan: 3, rowSpan: 1, accessor: "p25JumperP5", leftAlign: true },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [
      { title: "Track Circuit Adjustments ", colSpan: 9, rowSpan: 1, accessor: "loc", isTitleOnly: true },
      { title: "Fuse Locations ", colSpan: 9, rowSpan: 1, accessor: "loc", isTitleOnly: true },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [
      { title: "VTX Adj", colSpan: 3, rowSpan: 1, accessor: "loc", isTitleOnly: true },
      { title: "", colSpan: 6, rowSpan: 1, accessor: "vtxAdj", isValueOnly: true },
      { title: "10V", colSpan: 3, rowSpan: 1, accessor: "loc", isTitleOnly: true },
      { title: "", colSpan: 6, rowSpan: 1, accessor: "fuseLocations10v", isValueOnly: true },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [
      { title: "VRX Adj", colSpan: 3, rowSpan: 1, accessor: "loc", isTitleOnly: true },
      { title: "", colSpan: 6, rowSpan: 1, accessor: "vrxAdj", isValueOnly: true },
      { title: "50V", colSpan: 3, rowSpan: 1, accessor: "loc", isTitleOnly: true },
      { title: "", colSpan: 6, rowSpan: 1, accessor: "fuseLocations50v", isValueOnly: true },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [{ title: "Track Conditions", colSpan: 18, rowSpan: 1, accessor: "loc", isTitleOnly: true }],
  },
  {
    heights: { header1: "80px" },
    classes: { header2: "" },
    inlineBodyData: true,

    columns: [{ title: "Track Conditions", colSpan: 18, rowSpan: 1, accessor: "trackCond", isValueOnly: true }],
  },
];



// WEBPACK FOOTER //
// ./src/components/Reports/PATH/TrackCircuitReport/ST-1_DigiCodeTrackCircuit/ST-1_DigiCodeTrackCircuit_Schema.jsx